// Mock for @react-native-async-storage/async-storage on web
// Uses localStorage

const AsyncStorage = {
    getItem: async (key) => {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.error('[AsyncStorage] Error getting item:', e);
            return null;
        }
    },

    setItem: async (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.error('[AsyncStorage] Error setting item:', e);
        }
    },

    removeItem: async (key) => {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error('[AsyncStorage] Error removing item:', e);
        }
    },

    mergeItem: async (key, value) => {
        try {
            const existing = localStorage.getItem(key);
            if (existing) {
                const merged = { ...JSON.parse(existing), ...JSON.parse(value) };
                localStorage.setItem(key, JSON.stringify(merged));
            } else {
                localStorage.setItem(key, value);
            }
        } catch (e) {
            console.error('[AsyncStorage] Error merging item:', e);
        }
    },

    clear: async () => {
        try {
            localStorage.clear();
        } catch (e) {
            console.error('[AsyncStorage] Error clearing:', e);
        }
    },

    getAllKeys: async () => {
        try {
            return Object.keys(localStorage);
        } catch (e) {
            console.error('[AsyncStorage] Error getting keys:', e);
            return [];
        }
    },

    multiGet: async (keys) => {
        try {
            return keys.map(key => [key, localStorage.getItem(key)]);
        } catch (e) {
            console.error('[AsyncStorage] Error multi-get:', e);
            return [];
        }
    },

    multiSet: async (keyValuePairs) => {
        try {
            keyValuePairs.forEach(([key, value]) => {
                localStorage.setItem(key, value);
            });
        } catch (e) {
            console.error('[AsyncStorage] Error multi-set:', e);
        }
    },

    multiRemove: async (keys) => {
        try {
            keys.forEach(key => {
                localStorage.removeItem(key);
            });
        } catch (e) {
            console.error('[AsyncStorage] Error multi-remove:', e);
        }
    },

    multiMerge: async (keyValuePairs) => {
        try {
            for (const [key, value] of keyValuePairs) {
                await AsyncStorage.mergeItem(key, value);
            }
        } catch (e) {
            console.error('[AsyncStorage] Error multi-merge:', e);
        }
    },

    useAsyncStorage: (key) => ({
        getItem: () => AsyncStorage.getItem(key),
        setItem: (value) => AsyncStorage.setItem(key, value),
        removeItem: () => AsyncStorage.removeItem(key),
        mergeItem: (value) => AsyncStorage.mergeItem(key, value),
    }),
};

export default AsyncStorage;
export { AsyncStorage };
